import styled from 'styled-components';

import { $ } from '../..';
import { DividerProps } from './types';

export const DividerWrapper = styled.hr<$<DividerProps>>`
  width: 100%;
  margin-block: ${({ theme }) => theme.spacing(2)}px;
  border: none;

  border-top: 1px solid
    ${({ $color, theme }) =>
      $color
        ? theme.mosaiq.colors[$color as string] || theme.mosaiq.colors.grey20
        : theme.mosaiq.colors.grey20};
`;

export const VerticalDividerWrapper = styled.div<$<DividerProps>>`
  width: 1px;
  background-color: ${({ $color, theme }) =>
    $color
      ? theme.mosaiq.colors[$color as string] || theme.mosaiq.colors.grey20
      : theme.mosaiq.colors.grey20};
  height: 100%;
`;
